<template>
  <div class="content room-content">
    <div class="room-slider" v-if="!loading" :style="{background: color, 'border-bottom': '1px solid ' + color }">
      <div class="room-container-slider">
        <room-header-slider
          :name="name"
          :inline-address="inlineAddress"
          :area="area"
          :color="color"
          :label="longLabel"
        />
      </div>
    </div>
    <div class="listicons" :style="{background: color}" v-if="!loading">
      <div class="page container">
        <ul>
          <li v-for="(icon, index) in equipments" :index="index" :item="icon" :key="icon">
            <img :src="icon" class="icon"/>
          </li>
        </ul>
      </div>
    </div>
    <div id="contentsuite" v-if="!loading" class="container">
      <div class="page room-page">
        <div id="contentleft">
          <h1>{{contentName}}  <span class="fg-primary" v-if="longLabel">{{longLabel}}</span></h1>
          <p v-html="description"></p>
          <p v-html="equipment_text"></p>
        </div>
        <div class="content-right">
          <resa-picker />
        </div>
        <div class="room-footer-list" v-if="footer">
          <a href="javascript:void(0)" class="btn btn-std colored-btn orange-btn" @click="book">
            <span>
              {{$t('roomFinder.inputBook')}}
            </span>
          </a>
          <a :href="mapLink" target="_blank" class="btn btn-std colored-btn dark-btn-outline">
            <span>
              {{$t('room.locate')}}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {setBodySuite} from '../../helpers/body-class.helper';
  import {mapState} from 'vuex';
  import RoomHeaderSlider from './components/RoomHeaderSlider';
  import {MetaHelper} from "../../helpers/meta.helper";
  import {TextHelper} from "../../helpers/text.helper";
  import ResaPicker from "./components/resa-picker";

  const maxR = [1905, 600];
  export default {
    name: 'Room',
    metaInfo() {
      return this.meta;
    },
    data () {
      return {
        footer: false
      }
    },
    components: {ResaPicker, RoomHeaderSlider},
    watch: {
      $route(to, from) {
        if (to.params.id !== from.params.id) {
          this.$store.dispatch('room/fetch', {
            id: to.params.id,
            lang: this.$store.state.lang.currentLang
          })
        }
      },
      name(name) {
        if (name && name.length > 0 && (!this.$route.params.slug || TextHelper.slugify(this.name) !== this.$route.params.slug)) {
          this.$router.push({
            name: 'room',
            params: {id: this.$route.params.id, slug: TextHelper.slugify(this.name)}
          });
        }
      }
    },
    computed: {
      meta() {
        if (this.loading) return MetaHelper.home(this.$store.state.lang.currentLang);
        if (!this.metaInfo) return MetaHelper.room(this.name, this.area + 'm2 - ' + this.description);
        return {
          title: this.metaInfo.title,
          meta: [{
            vmid: 'description',
            name: 'description',
            content: this.metaInfo.description
          }]
        }
      },
      ...mapState({
        id: s => s.room.room.id,
        guestLimit: s => s.room.room.capacity_max,
        roomGroup: s => s.room.room.room_group,
        color: s => `#${s.room.room.color.slice(-6)}`,
        area: s => s.room.room.area,
        name: s => s.room.room ? s.room.room.text.short_name : '',
        loading: s => s.room.loading,
        zone: s => s.room.room.room_group.room_zone,
        metaInfo: s => s.room.room.meta,
        group: s => s.room.room.room_group.text.name,
        description: s => s.room.room.text.description,
        equipment_text: s => s.room.room.text.equipments,
        contentName: s => s.room.room.text.name,
        inlineAddress: s => s.room.room.address.inline,
        equipments: s => s.room.room.equipments.map(e => `${e.icon}`),
        longLabel: s => s.room.room.label ? s.room.room.label.long : null,
        mapLink: s => {
          if (s.room.room.address && s.room.room.address.inline) {
            return `https://www.google.com/maps/search/?api=1&query=${encodeURI(s.room.room.address.inline)}`;
          }
          return `https://www.google.com/maps/search/?api=1&query=${s.room.room.position.lat},${s.room.room.position.lng}`;
        }
      }),
    },
    async mounted() {
      setBodySuite();
      await this.$store.dispatch('room/fetch', {
        id: this.$route.params.id,
        lang: this.$store.state.lang.currentLang
      });
      await this.$store.dispatch('menu/setIndexActive', 2);

    },
    methods: {
      async book() {
        this.$store.commit('search/SET_SEARCH_ZONE', this.roomGroup.room_zone.id);
        this.$store.commit('search/SET_SELECTED', this.id);
        // this.$store.commit('search/SET_SEARCH_GROUP', [this.roomGroup.id]);
        await this.$router.push({name: 'search', params: {runAuto: true}});
      }
    }
  };
</script>

<style scoped>
  #txtslidesuite em, #txtslidesuite h2::before, .listicons {
    background-color: #445120;
  }

  .dark-btn-outline {
    border: 2px solid black;
    color: black;
    background: white;
    width: 241px;
    transition: all 300ms ease;
  }
  .dark-btn-outline:hover {
    background: black;
    color: white;
  }
  @media (max-width: 768px) {
    .dark-btn-outline {
      width: 316px;
    }
  }
  @media (max-width: 480px) {
    .dark-btn-outline {
      width: 236px;
    }
  }
  .room-footer-list {
    display: grid;
    grid-gap: 14px;
    padding: 20px 0;
    align-items: center;
  }
  .room-footer-list .btn {
    margin: 0 auto!important;
  }

  .colored-btn {
    padding: 10px;
  }

  .icon {
    height: 40px;
    width: 40px;
  }

  h1 span {
    font-size: .7em;
    margin-left: 4px;
  }

  h1 span::before {
    content: '- ';
  }
  @media (max-width: 1050px) {
    h1 span::before {
      content: '';
    }
    h1 span {
      display: block;
    }
  }

  .room-page {
    display: grid;
    grid-template-areas: 'b' 'a';
    grid-gap: 20px;
  }
  @media (min-width: 992px) {
    .room-page {
      grid-template-areas: 'a b';
      display: grid;
      grid-template-columns: auto 320px;
      grid-gap: 20px;
    }
  }

  .content-right {
    grid-area: b;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/pages/rooms/Room.vue